import { Calendar, House, LineChart, User } from 'lucide-react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useLanguage } from '../hooks/useLanguage'

const tabs = [
  { path: '/', zh: '首页', en: 'Home', icon: House },
  { path: '/calendar', zh: 'TOKEN2049', en: 'TOKEN2049', icon: Calendar },
  { path: '/markets', zh: '预测市场', en: 'Markets', icon: LineChart },
  { path: '/me', zh: '我的', en: 'Me', icon: User },
]

export function AppBottomNav() {
  const location = useLocation()
  const navigate = useNavigate()
  const { t } = useLanguage()

  return (
    <nav className="fixed inset-x-0 bottom-0 z-40 border-t border-gray-200 bg-white/95 pb-[max(env(safe-area-inset-bottom),4px)] backdrop-blur dark:border-gray-800 dark:bg-gray-900/95">
      <div className="mx-auto grid h-14 max-w-3xl grid-cols-4">
        {tabs.map(({ path, zh, en, icon: Icon }) => {
          const active = path === '/'
            ? location.pathname === '/'
            : location.pathname.startsWith(path)
          return (
            <button
              key={path}
              type="button"
              onClick={() => navigate(path)}
              className={`flex flex-col items-center justify-center gap-0.5 text-[11px] font-medium ${
                active ? 'text-blue-600 dark:text-blue-400' : 'text-gray-500 dark:text-gray-400'
              }`}
            >
              <Icon className="h-5 w-5" strokeWidth={active ? 2.4 : 2} />
              <span>{t(zh, en)}</span>
            </button>
          )
        })}
      </div>
    </nav>
  )
}
